import { isEmpty, notEmpty } from '@cck/common'
import _ from 'lodash'
import { atom, selector, selectorFamily } from 'recoil'

import { selectedStandardIdAtom } from 'atoms/standard/Standard'
import { dummyStandardIndexSelector } from 'services/dummy/DummyStandardIndex'
import { Index, IndexReply, getIndex } from 'services/standard_client'

// 함수는 먼저 정의
export function findIndexItemInner(indexItems: Index[], id: string[]): Index | undefined {
  if (isEmpty(indexItems)) {
    return
  }

  const numberOfDot = (indexItems[0].id.match(/\./g) || []).length + 1
  const targetId = id.slice(0, numberOfDot).join('.')
  const found = indexItems.find((item) => item.id === targetId)
  if (!found) {
    return
  }
  if (numberOfDot < id.length && notEmpty(found.children)) {
    return findIndexItemInner(found.children, id)
  }
  return found
}

export const getIndexItemSelector = selectorFamily<IndexReply, string>({
  key: 'getIndexItemSelector',
  get(standardId: string) {
    return async function ({ get }) {
      const indexMap = await get(dummyStandardIndexSelector)
      const cached = indexMap.get(standardId)
      if (cached) {
        return cached
      }
      // return indexMap.get(standardId) ?? { indexList: [] }
      return await getIndex(standardId)
    }
  }
})

export const indexItemsSelector = selector<IndexReply>({
  key: 'indexItemsSelector',
  get: async ({ get }) => {
    const selectedStandardId = get(selectedStandardIdAtom)
    if (selectedStandardId === '') {
      return { indexList: [] }
    }
    return get(getIndexItemSelector(selectedStandardId))
  }
})

export const selectedOneDepthIndexItemAtom = atom<Index | undefined>({
  key: 'selectedOneDepthIndexItemAtom',
  default: selector({
    key: 'selectedOneDepthIndexItemAtom/default',
    get: async ({ get }) => {
      const indexItems = await get(getIndexItemSelector('ASNPO'))
      return findIndexItemInner(indexItems.indexList, ['ns'])
    }
  })
})

export const selectedIndexItemAtom = atom<Index | undefined>({
  key: 'selectedIndexItemAtom',
  default: selector({
    key: 'selectedIndexItemAtom/default',
    get: async ({ get }) => {
      const oneDepthItem = await get(selectedOneDepthIndexItemAtom)
      if (!oneDepthItem) {
        return undefined
      }
      return findIndexItemInner(oneDepthItem.children, ['ns', '1'])
    }
  })
})

export const findIndexItemSelector = selectorFamily<
  Index | undefined,
  { standardId: string; id: string }
>({
  key: 'findIndexItemSelector',
  get({ standardId, id }) {
    return async function ({ get }) {
      const indexItems = get(getIndexItemSelector(standardId))
      const ids = _.split(id, '.')

      return findIndexItemInner(indexItems.indexList, ids)
    }
  }
})
